import React,{ useState,useEffect } from 'react'
import { Tabs,Input,Button} from 'antd'
import FileSaver from 'file-saver'
import XLSX from 'sheetjs-style'
import NetworkService from '../../services/NetworkService'
import {Link} from 'react-router-dom'
import {activeCC, activeREC, templateView} from '../../assets/tableViews'
import "react-pdf/dist/esm/Page/TextLayer.css";
import {useAtom} from 'jotai'
import CertificateTable from '../../components/CertificateTable'
import TemplateTable from '../../components/TemplateTable'
import { selectedRecord,retirementQuantity,accessTokenAtom } from "../../atoms";
import { useMsal, useAccount } from "@azure/msal-react";
import { graphrequest, loginRequest } from '../../authConfig';

 


function CertificateTemplate() {
  const [accessAtom,setAPIAtom]=useAtom(accessTokenAtom)
  const [currentTabTitle, setCurrentTabTitle] = useState('Active CC')
  const [residentialTemplates,setResidentialTemplates]=useState([]);
  const [businessTemplates,setBusinessTemplates]=useState([]);
  const [currentData,setCurrentData]=useState([])
  const [loading,setLoading]=useState(false)
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken,setAccessToken]=useState();


  const handleTabChange = (key) => {
    const currentTab = certificateTabs.find(t => t.key === key)
    if (!currentTab) return
    const tabLabel = currentTab.label
  }

  useEffect(()=>{
    async function getData(){
      
      if(account){
        instance.acquireTokenSilent({
          ...loginRequest,
          account: account,
      })
      .then((response) => {
          console.log('CH',response)
          
          setAccessToken(response.accessToken)
          return response.accessToken
      }).then((token)=>{
        const networkServiceObj = new NetworkService();
        networkServiceObj.getResidentialCertificateTemplateService(token).then(res=>{
          
          setCurrentData(res.data)
          setResidentialTemplates(res.data);
        }).then(()=>{
         networkServiceObj.getBusinessCertificateTemplateService(token).then(item=>{
             
             setCurrentData(item.data)
             setBusinessTemplates(item.data);
             setLoading(false)
           })
        })
      })
      }

    
    }
    setLoading(true);
    getData();
  },[])

  
  const certificateTabs =[
    {
        key: 1,
        label: 'Residential',
        children:<TemplateTable defaultColumns={templateView} dummyData={residentialTemplates} label={'Residential'} token={accessToken}></TemplateTable>,
        forcedRender:true,
      },
      {
        key: 2,
        label: 'C&I',
        children:<TemplateTable defaultColumns={templateView} dummyData={businessTemplates} label={'C&I'} token={accessToken}></TemplateTable>,
        forcedRender:true,
      },
  ]


  return (
    <div className="App">

    
     
      {/* {loading==false &&  <Tabs defaultActiveKey='1' items={secondTab} onChange={handleTabChange} destroyInactiveTabPane={true}></Tabs>} */}

      
 
   {loading==false?
   <div style={{ 'overflowX': 'auto',width:'50%',margin:"auto" ,marginTop:50}}>
   <Tabs items={certificateTabs} onChange={handleTabChange} destroyInactiveTabPane={true}></Tabs>
   </div>:null}
    </div>
  )
}

export default CertificateTemplate
